export default "__VITE_ASSET__8630df6b__"